import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import {
  TERMS_OF_SERVICE_STATUS,
  type SignStatus,
  type TermsOfServiceStatusResponse,
} from "./TermsAndConditionsApi";

export const signStatusEnum = {
  NOT_SIGNED: "NOT_SIGNED",
  SIGNED_ONLINE: "SIGNED_ONLINE",
  SIGNED_OFFLINE: "SIGNED_OFFLINE",
} as const satisfies Record<string, SignStatus>;

export interface UseTermsAndConditionsReturn {
  isTermsReminderTimePassed: boolean;
  showTerms: boolean;
}

const useTermsAndConditions = (): UseTermsAndConditionsReturn => {
  const [isTermsReminderTimePassed, setIsTermsReminderTimePassed] =
    useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const { data } = useQuery<TermsOfServiceStatusResponse>(
    TERMS_OF_SERVICE_STATUS
  );

  useEffect(() => {
    if (!!data) {
      const reminderTimePassed =
        !!data.terms_of_service_status?.reminder_time &&
        new Date(data.terms_of_service_status.reminder_time) <= new Date();
      setIsTermsReminderTimePassed(reminderTimePassed);

      if (
        !data?.terms_of_service_status ||
        (data?.terms_of_service_status?.sign_status ===
          signStatusEnum.NOT_SIGNED &&
          reminderTimePassed)
      ) {
        setShowTerms(true);
      }
    }
  }, [data]);
  return {
    isTermsReminderTimePassed,
    showTerms,
  };
};

export default useTermsAndConditions;
